/**
 * this component will display the card summary item information
 *
 * @module views/components/SummaryItemCard
 * @memberof -Common
 */
import './SummaryItemCard.scss';

import React from 'react';

import PropTypes from 'prop-types';

import Button from '@ulta/core/components/Button/Button';
import Link_Huge from '@ulta/core/components/Link_Huge/Link_Huge';
import Text from '@ulta/core/components/Text/Text';
import UltaAsset from '@ulta/core/components/UltaAsset/UltaAsset';
import { DXL_NAVIGATION_TYPE } from '@ulta/core/utils/constants/action';

import Divider from '@ulta/components/Divider/Divider';

/**
 * Represents a SummaryItemCard component
 *
 * @method
 * @param {SummaryItemCardProps} props - React properties passed from composition
 * @returns SummaryItemCard
 */
export const SummaryItemCard = function( props ){
  const { image, title, subTitle, action, onClick } = props;
  const hasLinkAction = action?.navigationType === DXL_NAVIGATION_TYPE.Redirect;

  return (
    <div className='SummaryItemCard'
      data-testid='summary-item-card'
    >
      <div className='SummaryItemCard__Content'>
        { image && (
          <UltaAsset { ...image }
            aspectRatio='1:1'
            width={ 64 }
            height={ 64 }
          /> ) }
        { title && (
          <div className='SummaryItemCard__Content__Title'>
            <Text htmlTag='h1'
              textStyle='title-5'
            >
              { title }
            </Text>
          </div>
        ) }
        { subTitle && (
          <div className='SummaryItemCard__Content__SubTitle'>
            <Text textStyle='body-lg'
              color='neutral-700'
              textAlign='center'
            >
              { subTitle }
            </Text>
          </div>
        ) }
      </div>
      { action?.label && (
        <>
          <Divider />
          <div className='SummaryItemCard__Actions'>
            { hasLinkAction ? (
              <Link_Huge likeButtonPrimary
                url={ action.url }
                action={ action }
              >
                { action.label }
              </Link_Huge>
            ) : (
              <Button
                ariaLabel={ action.label }
                fullWidth={ true }
                action={ action }
                label={ action.label }
                onClick={ onClick }
              />
            ) }
          </div>
        </>
      ) }
    </div>
  );
};

/**
 * Property type definitions
 * @typedef SummaryItemCardProps
 * @type {object}
 * @property {object} image - Sets value for an image
 * @property {string} title - Sets value for the title
 * @property {string} subTitle - Sets value for the subTitle
 * * @property {object} action - An action object containing label text and url
 * @property {function} onClick - Function as the event handler
 */
export const propTypes =  {
  image: PropTypes.object,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  action: PropTypes.shape( {
    label: PropTypes.string,
    url: PropTypes.string,
    navigationType: PropTypes.string,
    clientActionType: PropTypes.string
  } ),
  onClick: PropTypes.func
};

SummaryItemCard.propTypes = propTypes;

export default SummaryItemCard;